import { lazy, Suspense, type ReactNode } from "react";

import { GlobeIcon } from "@/components/icons";
import { RequirePermission } from "@/components/RequirePermission";
import { ROUTES } from "@/config/routes";
import type { FeatureModule } from "@/types/feature";

const SiteMonitorPage = lazy(() =>
  import("./SiteMonitorPage").then((m) => ({ default: m.SiteMonitorPage }))
);

function Loader() {
  return <div style={{ padding: 20, color: "var(--text-muted)", fontSize: 14 }}>Loading…</div>;
}

/** Gate the route on feature.site-monitor.access (client mirror of the server). */
function guard(element: ReactNode): ReactNode {
  return (
    <RequirePermission perm="feature.site-monitor.access" redirectTo={ROUTES.overview}>
      <Suspense fallback={<Loader />}>{element}</Suspense>
    </RequirePermission>
  );
}

/**
 * Websites monitor registration. Reads GET /api/site-monitor (see source.ts),
 * built from the collector's stored runs. Gated on
 * feature.site-monitor.access — seeded to no role but superadmin, granted per
 * person.
 */
export const siteMonitorFeature: FeatureModule = {
  id: "site-monitor",
  navItems: [
    {
      id: "site-monitor",
      label: "Websites",
      path: ROUTES.websites,
      icon: GlobeIcon,
      requires: "feature.site-monitor.access",
    },
  ],
  routes: [{ path: ROUTES.websites, element: guard(<SiteMonitorPage />) }],
};
